import * as React from 'react'
import { Box, Typography } from 'cs-kevlar-react'
import { AgencyLicenseEvents } from '../../../../api'

interface AgencyMigrationPlanProps {
  agencyLicenseEvents: AgencyLicenseEvents
}

export const AgencyMigrationPlan: React.FunctionComponent<AgencyMigrationPlanProps> = ({
  agencyLicenseEvents,
}) => {
  const hasAgencyEvents = agencyLicenseEvents.hasEvents
  const hasAgencyCreatedEvents =
    agencyLicenseEvents.createdEvents?.length > 0 ?? false
  const hasAgencyRemovedEvents =
    agencyLicenseEvents.removedEvents?.length > 0 ?? false
  const hasAgencySkippedEvents =
    agencyLicenseEvents.creationSkippedEvents?.length > 0 ?? false

  if (!hasAgencyEvents) return null

  return (
    <Box>
      <Typography>Agency Changes</Typography>
      {(hasAgencyCreatedEvents ||
        hasAgencyRemovedEvents ||
        hasAgencySkippedEvents) && (
        <ul>
          {hasAgencyCreatedEvents &&
            agencyLicenseEvents.createdEvents.map((createEvent, idx) => (
              <li key={`AgencyCreationEvents::${idx}`}>
                <Typography>
                  {createEvent.targetLicense.name} created
                </Typography>
              </li>
            ))}
          {hasAgencyRemovedEvents &&
            agencyLicenseEvents.removedEvents.map((removedEvent, idx) => (
              <li key={`AgencyRemovalEvents::${idx}`}>
                <Typography>{removedEvent.license.name} removed</Typography>
              </li>
            ))}
          {hasAgencySkippedEvents &&
            agencyLicenseEvents.creationSkippedEvents.map(
              (skippedEvent, idx) => (
                <li key={`AgencySkipEvents::${idx}`}>
                  <Typography>
                    {skippedEvent.targetAgencyExternalId} skipped
                  </Typography>
                </li>
              ),
            )}
        </ul>
      )}
    </Box>
  )
}
